
export const ACTIONS = {
  SET_FILTERS: 'stats/SET_FILTERS',
}

export default ACTIONS;
